import { classnames } from '@aibees/shared/utils';
import { memo } from 'react';
import { useWorkHistoryPresentRoles } from '../../../contact-details/components/work-history';
import { ProfileRolesItem } from '../profile-roles-item';
import * as Styled from './styles';
import * as SX from './sx';
import type { CompanySummaryProps as Props } from './types';
import { usePersonReadDataContext } from '@aibees/elephant/context';

export const CompanySummary = memo(
  ({ className, isMainPage, currentRoles }: Props) => {
    const allPresentRoles = useWorkHistoryPresentRoles();
    const { api } = usePersonReadDataContext();

    if (!currentRoles) return null;

    return (
      <Styled.Wrapper
        className={classnames('CompanySummary', className)}
        sx={SX.root}
      >
        {allPresentRoles?.map((companyData, index) => (
          <ProfileRolesItem
            key={index}
            companyData={companyData}
            isMainPage={isMainPage}
          />
        ))}
      </Styled.Wrapper>
    );
  }
);

CompanySummary.displayName = 'CompanySummary';
